import { newsletter } from './newsletter'

function addFooterSocials() {
    const footerBottom = document.querySelector('.footer-bottom')

    if (footerBottom) {
        const newContainer = document.createElement('div')
        newContainer.classList.add('container', 'footer-wrapper')

        const footerSocials = document.createElement('div')
        footerSocials.classList.add('footer-socials')

        footerSocials.innerHTML = `
            <a href="https://www.instagram.com/hellococo_skcz/" target="_blank">
                <img src="/user/documents/upload/Ikony/instagram.svg" alt="instagram"/>
            </a>
            <a href="https://www.facebook.com/hellococo.skcz/" target="_blank">
                <img src="/user/documents/upload/Ikony/facebook.svg" alt="facebook"/>
            </a>
            <a href="https://www.tiktok.com/@hellococo.skcz" target="_blank">
                <img src="/user/documents/upload/Ikony/tiktok.svg" alt="tiktok"/>
                
            </a>
        `

        const signature = document.getElementById('signature')
        const copyright = document.querySelector('.copyright')

        if (signature) {
            const ableLink = document.createElement('a')
            ableLink.href = 'https://www.able.cz'
            ableLink.target = '_blank'
            ableLink.innerHTML = `<img src="/user/documents/upload/Ikony/able-logo.svg" alt="able"/>`
            signature.appendChild(ableLink)
        }

        if (signature && copyright) {
            newContainer.appendChild(signature)
            newContainer.appendChild(footerSocials)
            newContainer.appendChild(copyright)
        }

        while (footerBottom.firstChild) {
            footerBottom.removeChild(footerBottom.firstChild)
        }

        footerBottom.appendChild(newContainer)
    }
}

function instagram() {
    $('#dklab_instagram_widget_heading').addClass('container')
    $('#dklab_instagram_widget_inner').addClass('container')
}

export function initFooter() {
    newsletter()
    addFooterSocials()
    setTimeout(() => {
        instagram()
        $('#signature').attr('style', 'display: flex; align-items: center')
    }, 100)
}
